import React from 'react'
import './SideNav.css'
import { BsFileBarGraph, BsPen, BsPerson } from 'react-icons/bs'
import { BiChevronLeft, BiChevronRight, BiLink, BiLogOutCircle } from 'react-icons/bi'
import { NavLink } from 'react-router-dom'
import { API_URL } from '../config'

const NAV_ITEMS = [
  {
    section: 'WORKSPACE',
    items: [
      { label: 'Dashboard', icon: <BsFileBarGraph />, key: 'in' },
      { label: 'Partner Links', icon: <BiLink />, key: 'affiliate-link' },
      { label: 'Feedback', icon: <BsPen />, key: 'feedback' },
    ],
  },
  {
    section: 'ACCOUNT',
    items: [{ label: 'My Account', icon: <BsPerson />, key: 'profile' }],
  },
]

const SideNavAff = ({ collapsed = false, onToggle, onNavigate }) => {
  const handleLogout = async () => {
    try {
      await fetch(`${API_URL}/apps/kscanner/logout.php`, {
        method: 'GET',
        credentials: 'include',
      })
    } catch (error) {
      console.error('Logout request failed:', error)
    } finally {
      localStorage.clear()
      window.location.href = '/login'
    }
  }

  const handleNavigate = () => {
    if (onNavigate) onNavigate()
  }

  return (
    <aside className={`kx-sidenav ${collapsed ? 'is-collapsed' : ''}`}>
      <div className="kx-sidenav__top">
        <div className="kx-sidenav__control-row">
          {!collapsed && <span className="kx-sidenav__eyebrow">MENU</span>}

          <button
            type="button"
            className="kx-sidenav__toggle"
            onClick={onToggle}
            aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {collapsed ? <BiChevronRight /> : <BiChevronLeft />}
          </button>
        </div>

        <nav className="kx-sidenav__navigation" aria-label="Main navigation">
          {NAV_ITEMS.map((section) => (
            <div className="kx-sidenav__section" key={section.section}>
              {!collapsed && <div className="kx-sidenav__section-label">{section.section}</div>}

              <ul className="kx-sidenav__list">
                {section.items.map(({ key, label, icon }) => (
                  <li className="kx-sidenav__item" key={key}>
                    <NavLink
                      to={`/${key}`}
                      exact
                      activeClassName="is-active"
                      className="kx-sidenav__link"
                      onClick={handleNavigate}
                      title={collapsed ? label : undefined}
                    >
                      <span className="kx-sidenav__icon" aria-hidden="true">
                        {icon}
                      </span>
                      {!collapsed && <span className="kx-sidenav__label">{label}</span>}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
      </div>

      <div className="kx-sidenav__bottom">
        <button
          type="button"
          className="kx-sidenav__link kx-sidenav__logout"
          onClick={handleLogout}
          title={collapsed ? 'Logout' : undefined}
        >
          <span className="kx-sidenav__icon" aria-hidden="true">
            <BiLogOutCircle />
          </span>
          {!collapsed && <span className="kx-sidenav__label">Logout</span>}
        </button>

        {!collapsed && (
          <div className="kx-sidenav__footer">
            <span className="kx-sidenav__footer-dot" />
            <span>Karamale Partner</span>
          </div>
        )}
      </div>
    </aside>
  )
}

export default SideNavAff
